<template>
  <book-list></book-list>
</template>

<script>
import ViewBook from "./products/ViewBook.vue";
import BookList from "./products/BookList.vue";

export default {
  components: {
    "book-list": BookList
  }
};
</script>
